import React from 'react'

import {
  TokenDetailsContainer,
  TokenDetailsTitle,
  TokenDetailsValue,
} from './TokenDetailsItem.styles'

interface TokenDetailsItemProps {
  title: string
  value: string | React.ReactNode
}

const TokenDetailsItem: React.FCC<TokenDetailsItemProps> = ({
  title,
  value,
}) => (
  <TokenDetailsContainer>
    <TokenDetailsTitle>{title}</TokenDetailsTitle>
    <TokenDetailsValue>{value}</TokenDetailsValue>
  </TokenDetailsContainer>
)

export default TokenDetailsItem
